import { useEffect } from 'react';

import Tippy from '@tippyjs/react';

import { Alert } from 'components/shared/Alert/Alert';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import PayrocOnlinePayment from 'components/Payments/payroc/PayrocOnlinePayment';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

const NewCard = ({ onError, hideButton = false, buttonText, fieldRows, onLoadError }) => {
  const { handlePayment, setFieldValue } = usePaymentContextApi();
  const { values, terminalPin, forceSaveCard } = usePaymentContext();

  // A card can only be saved when it can be attached to a patient
  const hasPatient = Boolean(values.patientId);
  const isRecurringPayment = Boolean(values.recurringPayment);
  const isSaveCard = forceSaveCard || values.saveCard || isRecurringPayment;
  const isSaveCardDisabled = isRecurringPayment || forceSaveCard;

  useEffect(() => {
    if (hasPatient && isSaveCardDisabled && !values.saveCard) {
      setFieldValue('saveCard', true);
    }
  }, [hasPatient, isSaveCardDisabled, values.saveCard, setFieldValue]);

  return (
    <PayrocOnlinePayment
      key="pay-with-new-card"
      id="pay-with-new-card"
      amount={values.amount}
      handlePayment={handlePayment}
      onError={onError}
      hideButton={hideButton}
      terminalPin={terminalPin}
      className="self-end"
      fieldRows={fieldRows}
      buttonText={buttonText}
      onLoadError={onLoadError}>
      {hasPatient && (
        <div className="flex w-full flex-col gap-3 self-start">
          {!isSaveCardDisabled ? (
            <Tippy content="This card will be saved for future payments." className="tippy-dark">
              <Checkbox
                size={16}
                isChecked={isSaveCard}
                disabled={isSaveCardDisabled}
                onChange={(event) => setFieldValue('saveCard', event.target.checked)}
                className="max-w-[456px]"
                label="Save this card for future payments."
              />
            </Tippy>
          ) : (
            <Alert
              message="This card will be saved for future payments"
              variant="lighter"
              color="primary"
              className="w-full"
            />
          )}
        </div>
      )}
    </PayrocOnlinePayment>
  );
};

export default NewCard;
